@if (dataContext?.length > 0) {
  <section class="info-note-component">
    <div class="info-note-digit" #tooltipIcon [ngClass]="{ 'info-note-digit--smaller': dataContext?.length > 9 }">
      {{ dataContext.length > 9 ? '9+' : dataContext.length }}
    </div>
    @if (dataContext.length > 0) {
      <div class="tooltip-content" #tooltip>
        <ul>
          @for (note of dataContext; track note; let i = $index) {
            <li>
              <div class="note-content" [class.clickable-note]="isClickable" (click)="click($event, note)">
                <div class="content-wrapper">
                  @if (note.header.length > 0) {
                    <p class="notification-header">
                      {{ i + 1 + '. ' + note.header }}
                    </p>
                  }
                  <p class="notification-text">{{ note.text }}</p>
                </div>
                <div class="image-container">
                  <img src="assets/icons/component_icons/download-white.png" />
                </div>
              </div>
            </li>
          }
        </ul>
      </div>
    }
  </section>
}
